import { InjectionToken, ValueProvider } from '@angular/core';

export const CUSTOMER_API_ORIGIN = new InjectionToken<string>('Customer API Origin');
export const provideCustomerApiOrigin = (origin: string): ValueProvider => ({
  provide: CUSTOMER_API_ORIGIN,
  useValue: origin,
});
